import { IC2paConfig, ActiveStats } from './IVbC2paContract';

import { c2paStatReporterInstance } from '../../player/c2pa/VbC2paStatsReporter';
import { PlayerRuntimeConfig } from '../VbPlayerRuntimeConfig';

export class C2paMp4Validator {
	private worker: Worker;
	constructor(private c2paConfig: IC2paConfig) {
	}

	public async init(videoUrl: string): Promise<any | null> {
		try {
			this.worker = new Worker(new URL('C2paMp4.vbworker.js', PlayerRuntimeConfig.workerBaseUrl), { type: 'module' });
			this.worker.onmessage = this.onWorkerMessage;
			this.worker.postMessage({ url: videoUrl, c2paConfig: { wasmSrc: this.c2paConfig.wasmSrc, trustAnchors: this.c2paConfig.trustAnchors } });
		} catch (error) {
			console.error('C2PA validation failed:', error);
			return null;
		}
	}

	private onWorkerMessage(event: MessageEvent): void {
		try {
			console.warn('C2PA MP4 Worker Message:', event.data);

			const { c2paInfo, msg } = event.data;
			if (c2paInfo) {
				// Find the key in SUPPORTED_MIME_TYPES whose value matches c2paInfo.type
				const typeKey = c2paInfo.type?.toLowerCase().includes('audio') ? 'audio' : 'video';

				const activeStats: ActiveStats = {
					overallVerified: c2paInfo.verified,
					type: typeKey as 'audio' | 'video',
					activeSegmentStats: {
						verified: c2paInfo.verified,
						manifest: c2paInfo.manifestData,
						validationResults: c2paInfo.validationResults,
						segmentName: c2paInfo.file,
					}
				};
				c2paStatReporterInstance.reportMp4Stats(activeStats);
			}
		} catch (error) {
			console.error('Error handling C2PA MP4 Worker message:', error);
		}
	}

	public destroy(): void {
		try {
			this.worker?.postMessage({ action: 'terminate' });
			this.worker?.terminate();
			c2paStatReporterInstance.destroy();
		} catch (error) {
			console.error('C2PA MP4 plugin Error during destroy:', error);
		}
	}
}
